import { createApp } from "vue";

import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import CssInstall from "./css-install";
import apiInstance from "./axios";
import openApiInstance from "./axios-open-api";
import crmApiInstance from "./crm-axios";
import counselApiInstance from "./counsel-axios";
import naive from "naive-ui";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';


const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(CssInstall);
appInstance.use(naive);
appInstance.use(Antd)
appInstance.config.globalProperties.$apiInstance = apiInstance;
appInstance.config.globalProperties.$openApiInstance = openApiInstance;
appInstance.config.globalProperties.$crmApiInstance = crmApiInstance;
appInstance.config.globalProperties.$counselApiInstance = counselApiInstance;
appInstance.mount("#app");
